document.body.addEventListener('htmx:afterSwap', (event) => {
    if (!window.turnstile) {
        return;
    }

    event.detail.target.querySelectorAll('.cf-turnstile').forEach((element) => {
        if (!element.querySelector('iframe')) {
            window.turnstile.render(element);
        }
    });
});
